import { baseService } from '../baseService';
import HttpClient from '../../services/HttpClient';

export const reportLoadingErrors = baseService<string, void>((message) =>
  HttpClient.post('emails/report-content-error', { message }),
);
